import React from 'react';
import PropTypes from 'prop-types';
import {
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';

export const CashFlowPageActions = ({
  cashFlowResource,
  onAddJob,
  onAddExpense,
}) => {
  return (
    <FDStack spacing={1}>
      {cashFlowResource.withRelationship(fr.relationships.addJob.name, (rel) => {
        return (
          <FDPrimaryActionButton
            label={rel.meta('prompt')}
            onClick={() => onAddJob(rel)}
            size={'sm'}
          />
        );
      }, () => null)}
      {cashFlowResource.withRelationship(fr.relationships.addExpense.name, (rel) => {
        return (
          <FDPrimaryActionButton
            label={rel.meta('prompt')}
            onClick={() => onAddExpense(rel)}
            size={'sm'}
          />
        );
      }, () => null)}
    </FDStack>
  );
};

CashFlowPageActions.defaultProps = {
};

CashFlowPageActions.propTypes = {
  cashFlowResource: PropTypes.object.isRequired,
  onAddJob: PropTypes.func.isRequired,
  onAddExpense: PropTypes.func.isRequired,
};
